export const FOOTER = "FOOTER";
export const SHOW_FOOTER = "SHOW_FOOTER";
export const SHOW_FOOTER_UI = "SHOW_FOOTER_UI";
